import styles from "./switch.module.css";
type SwitchProps = {
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
};

export function Switch({
    checked,
    onChange,
    disabled = false,
}: SwitchProps) {
    return (
        <button
            type="button"
            role="switch"
            aria-checked={checked}
            disabled={disabled}
            className={`${styles.switch} ${checked ? styles.checked : ""
                }`}
            onClick={() => onChange(!checked)}
        >
            <span className={styles.thumb} />
        </button>
    );
}
